import { render } from "./metrics.vue?vue&type=template&id=12e0c14a&scoped=true"
import script from "./metrics.vue?vue&type=script&lang=js"
export * from "./metrics.vue?vue&type=script&lang=js"

import "./metrics.vue?vue&type=style&index=0&id=12e0c14a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e0c14a"]])

export default __exports__